/**
 * Shared diagnostics helpers for the TTS read-along subsystem. One module so
 * the relative-time baseline in `tsMs` is shared by every `[TTS ...]` log
 * line, whichever class emits it.
 */

export const READY_STATE_NAMES = [
  'HAVE_NOTHING',
  'HAVE_METADATA',
  'HAVE_CURRENT_DATA',
  'HAVE_FUTURE_DATA',
  'HAVE_ENOUGH_DATA',
] as const;

export function fmtRanges(r: TimeRanges): string {
  if (!r || r.length === 0) return 'none';
  const out: string[] = [];
  for (let i = 0; i < r.length; i++) {
    out.push(`[${r.start(i).toFixed(3)}, ${r.end(i).toFixed(3)}]`);
  }
  return out.join(',');
}

let __ttsLogStart = 0;
export function tsMs(): string {
  if (!__ttsLogStart) __ttsLogStart = performance.now();
  const rel = (performance.now() - __ttsLogStart).toFixed(0);
  // Absolute wall-clock too, so these lines can be lined up against
  // proxy/backend logs to attribute latency to the right side.
  const now = new Date();
  const wall =
    `${String(now.getHours()).padStart(2, '0')}:` +
    `${String(now.getMinutes()).padStart(2, '0')}:` +
    `${String(now.getSeconds()).padStart(2, '0')}.` +
    `${String(now.getMilliseconds()).padStart(3, '0')}`;
  return `+${rel}ms ${wall}`;
}
